'use es6';

import { BOUNDS_DELEGATE_ATTRIBUTE, BOUNDS_DELEGATE_ATTRIBUTE_SELECTOR } from 'layout-dnd-utils/constants/index';
const getElementsWithBoundsDelegateAttribute = () => {
  return document.querySelectorAll(BOUNDS_DELEGATE_ATTRIBUTE_SELECTOR);
};
export const getDelegatedBoundsElementsByNameOrPath = () => {
  const delegateElements = getElementsWithBoundsDelegateAttribute();
  const delegateElementsByNameOrPath = {};
  for (const delegateEl of delegateElements) {
    const attributeValue = delegateEl.getAttribute(BOUNDS_DELEGATE_ATTRIBUTE);
    if (attributeValue) {
      delegateElementsByNameOrPath[delegateEl.getAttribute(BOUNDS_DELEGATE_ATTRIBUTE)] = delegateEl;
    }
  }
  return delegateElementsByNameOrPath;
};